import React from 'react';

export default class DataSummary extends React.Component {
	
  constructor(props) {
		super(props);

    const data = this.props.data || []

    this.state = {
      data: data,
      loading: data && data.length ? false : true
    }

    this.loadData = this.loadData.bind(this)        
	}

  componentDidMount() {
    if (!this.state.data || this.state.data.length === 0) {
      this.loadData()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.endpoint !== this.props.endpoint) {
      this.loadData()
    }
  }

	render() {
		// console.log(this.props)
    let data = null
    if (this.state.data && this.state.data.length) {
      data = this.state.data.map((d) => (
        <div className="category-section" key={d.name}>
          <span className="category-name">{d.name}</span>
          <span className="category-value">{d.value}</span>
        </div>
      ))
    }

		return (
			<div className="DataSummary">
				{this.state.loading ? (
					<div className="loadingOverlay">
						<div className="spinner" />
					</div>
				) : null}
				<div>
					{data}
				</div>
			</div>
		);
	}

  loadData() {
    this.setState({loading: true});
    $.ajax({
      type: 'GET',
      url: this.props.endpoint,
    }).done((data) => {
    	//console.log('DataSummary loadData done', data);
      this.setState({data: data, loading: false})
    });
  }

}
